<template>
  <div>
    <!-- 再次打印 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" width="480px" center>
      <div class="content">
        <div class="text">
          注意：标签申请界面后直接打开打印界面，退出后需要重新申请，请谨慎操作
        </div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <!-- 申请数量 -->
          <el-form-item :label="$t('message.applicationQuantity')" prop="num">
            <el-input v-model="ruleForm.num" type="number" @input="handleInput"></el-input>
          </el-form-item>
          <!-- 申请原因 -->
          <el-form-item :label="$t('message.reasonForApplication')" prop="print_reason">
            <el-select v-model="ruleForm.print_reason" placeholder="请选择" clearable>
              <el-option v-for="item in options" :key="item.label" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
            <el-input v-model="ruleForm.print_reason" type="textarea"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.ok") }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    order_detail_tag_id: { type: String },
  },
  data() {
    return {
      options: [
        {
          label: '打印机故障'
        },
        {
          label: '换卷纸'
        },
        {
          label: '标签破损'
        },
        {
          label: '操作失误'
        },
      ],
      ruleForm: {
        num: 1,
        print_reason: '',
      },
      dialogVisible: false,
      rules: {
        // 支付方式
        num: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
        print_reason: [
          {
            required: true,
            // 此参数不能为空
            message: this.$t("message.thisParameterCannotBeEmpty"),
            trigger: "blur",
          },
        ],
      }
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.ruleForm = {
          num: 1,
          print_reason: '',
        }
      } else {
        this.$parent.printTagData = null;
        this.dialogVisible = false
        this.$parent.tabPrintNum = 1
        this.$forceUpdate();
      }
    }
  },
  methods: {
    // 保存
    save() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.ruleForm.order_detail_tag_id = this.order_detail_tag_id
          this.$api.porderApi.printReasonStore(this.ruleForm).then((res) => {
            this.$parent.tabPrintNum = this.ruleForm.num
            this.$nextTick(() => {
              this.$print(this.$parent.$refs.tabPrint);
              this.$parent.printTagData = null;
              this.dialogVisible = false
              this.$parent.tabPrintNum = 1
              this.$forceUpdate();
            },)
          })
        }
      })
    },
    // 不允许出现负数
    handleInput(value) {
      // 将输入值转换为数字，然后去除开头的负号
      const number = Number(value.replace(/^-/, ''));
      // 如果输入的是负数或者非数字，则清空输入
      if (isNaN(number) || number < 0) {
        this.ruleForm.num = '';
      } else {
        // 否则更新输入值
        this.ruleForm.num = number.toString();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .text {
    color: red;
    font-size: 16px;
    font-weight: 600;
    margin: 24px 0;
  }

  /deep/.el-textarea__inner {
    height: 100px !important;
    resize: none;
  }
}
</style>